import React from "react";
import { CheckIcon } from "lucide-react";
import { sessionAssets, workflowSteps } from "../data/landing";
export function SolutionSection() {
  return <section className="section" id="how-it-works" data-id="element-212" data-mp="3abm0g6sco8w7">
      <div className="shell" data-id="element-213" data-mp="3o9k8kug2v939">
        <div className="section-intro" data-id="element-214" data-mp="3oalnja07sfq9">
          <p className="eyebrow" data-id="element-215" data-mp="3jah53efqxaxe">A CLEAR PLAN BEFORE THE SESSION</p>
          <h2 data-id="element-216" data-mp="3jcacivy6nz6g">
            Prepare the people.
            <br data-id="element-217" data-mp="13t15rwfmttb" />
            <span data-id="element-218" data-mp="139u568blpu2">The session structure is already there.</span>
          </h2>
          <p data-id="element-219" data-mp="3t8wu9bv7qa49">Every session follows the same structure, so once you have run one, the next feels familiar to you and your team.</p>
        </div>
        <ol className="steps-grid" data-id="element-220" data-mp="atmbkpku92vz">
          {workflowSteps.map((step, i) => <li key={step.title} data-id="element-221" data-mp="5wm4cbc95u3a" data-mpi={i}>
              <span className="step-number" data-id="element-222" data-mp="5xnhqmgqqso6">0{i + 1}</span>
              <h3 data-id="element-223" data-mp="ktd78ul4xnxn">{step.title}</h3>
              <p data-id="element-224" data-mp="kqh5swa2wh4g">{step.text}</p>
            </li>)}
        </ol>
        <div className="included-grid" data-id="element-225" data-mp="fv1x0iqxhbew">
          {sessionAssets.map(item => <div key={item.title} data-id="element-226" data-mp="36bno4gfcguxt">
              <CheckIcon size={19} aria-hidden="true" data-id="element-227" data-mp="36cp1wsnqvvj8" />
              <div data-id="element-228" data-mp="3baqi95tsdgr0">
                <h3 data-id="element-229" data-mp="3ba8oqgyidgms">{item.title}</h3>
                <p data-id="element-230" data-mp="3fbafe9ed0kd5">{item.text}</p>
              </div>
            </div>)}
        </div>
        <p className="prep-note" data-id="element-231" data-mp="3fdn5j9u9u11a">Review your chosen session and check policy details before facilitating.</p>
      </div>
    </section>;
}